import React, { useState } from 'react';
import './MobileHeader.scss';
import UOSLogo from '../../assets/UOS-logo.png';
import { Squash as Hamburger } from 'hamburger-react';
import Sidebar from '../Sidebar/Sidebar';
import { Link } from 'react-router-dom';
import MobileHeaderSmall from '../MobileHeaderSmall/MobileHeaderSmall';
import Banner2 from '../../assets/main-picture.jpg';
import Banner3 from '../../assets/430x300.jpg';

const MobileHeader = () => {
  const [isOpen, setOpen] = useState(false);

  const handleSidebarOpen = () => {
    return setOpen(false);
  };

  return (
    <div className="mobile-header">
      {isOpen && <Sidebar handleSidebarOpen={handleSidebarOpen} isOpen={isOpen} />}
      <div className="inner-container">
        <MobileHeaderSmall main={true} />
        {/* <div className="navigation">
          <Link to={'/'}>
            <img className="image" src={''} />
          </Link>
          <div className="burger-menu">
            {!isOpen && <Hamburger toggled={false} toggle={setOpen} color="white" />}
          </div>
        </div> */}
        <div className="context">
          <div className="image-wrapper">
            <img className="img-first" src={Banner3} alt="" />
            <img className="img-second" src={Banner3} alt="" />
          </div>
          <p className="title animatedFadeInUp fadeInUp">27. GODIŠNJE SAVETOVANJE UZPOS i UOS</p>
          <p className="sub-title-first animatedFadeInUp fadeInUp">
            „Pravo osiguranja danas: Stanje, tekuće reforme i praktična pitanja”
          </p>
          {/* <p className="sub-title-second-first animatedFadeInUp fadeInUp">Džon F. Kenedi</p> */}
          {/* <p className="sub-title animatedFadeInUp fadeInUp">Hotel Zlatibor 28.11.-01.12.2023.</p> */}
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
